/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import editicoSvg from '../../../../public/edit-product.svg';
import drprocoSvg from '../../../../public/prodr.svg';
import { showLoading } from 'react-global-loading';
import ProductService from '../../../../services/ProductService';
import moment from "moment";
export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
class MissionAllProducts extends React.Component {
  constructor(props) {
    super(props);

    const url = new URL(window.location);
    showLoading(true);
    this.state = {
      pendingProducts: [], filteredList: [], approved: [], pending: [], currentPage: url.searchParams.get('page') ? parseInt(url.searchParams.get('page')) : 1,
      statusCount: {}, statusType: 1
    };
  }

  componentDidMount = () => {
    if (this.state.currentPage > 1) {

      for (let i = 1; i <= this.state.currentPage; i++) {
        this.getProductList(i, this.state.statusType);
      }
    }
    else this.getProductList(this.state.currentPage, this.state.statusType);
  };

  getProductList = (page, status) => {
    ProductService.fetchAllProducts({ 'page': page, 'status': status }).then((result) => {
      if (!result) {
        return;
      }
      this.setState((prevState) => ({
        statusCount: result,
        filteredList: [...prevState.filteredList, ...result.data]
      }));

      showLoading(false);
    })
      .catch((err) => {
        console.error(err);
      });
  };


  productType = (page, type) => {
    let filteredList = [];
    this.setState({ statusType: type });
    const url = new URL(window.location);
    url.searchParams.set('page', page);
    window.history.pushState(null, '', url.toString());
    this.getProductList(page, type);
    this.setState({ filteredList });
  };

  addProduct = () => {
    this.props.history.push({ pathname: '/super/add-product' });
  };

  onLoad = () => {
    this.setState({ currentPage: parseInt(this.state.currentPage) + 1 })
    this.getProductList(this.state.currentPage + 1, this.state.statusType)

    const url = new URL(window.location);
    url.searchParams.set('page', this.state.currentPage + 1);
    window.history.pushState(null, '', url.toString());

  }

  render() {
    const { filteredList, statusType, statusCount } = this.state;
    let fullyLoaded;
    switch (statusType) {
      case 1://all
        fullyLoaded = filteredList.length === statusCount.total ? true : false;
        break;
      case 2://pending
        fullyLoaded = filteredList.length === statusCount.pending ? true : false;
        break;
      case 3://approved
        fullyLoaded = filteredList.length === statusCount.approved ? true : false;
        break;
    }
    return (
      <div className="container pt-2">
        {/* <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">All Products</li>
          </ol>
        </nav> */}
        <div className="row mt-5 mb-1">
          <div className="col-md-12 head-title">
            <h4 className="t0">Product Approvals, <span className="linear-title">{userData.blog_id.blogname}</span></h4>
            {/* <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus
            </p> */}
          </div>
          {/* <div className="col-md-2 d-flex align-items-center justify-content-center">
            <Link to="/create-event" className="btn theme-btn-fill">
              <i className="fa fa-plus-circle" aria-hidden="true"></i> Add New Product
            </Link>
          </div> */}

          {/* <div className="col-12">
            <div className="row">
              <span className="text-secondary d-block mb-2">
                <i className="fa fa-filter" aria-hidden="true" /> Filter Products
              </span>
              <div className="col-4">
                <div className="form-group mb-4 position-relative has-search">
                  <span className="fa fa-search form-search"></span>
                  <input type="text" className="form-control pd-tb-675em" name="searchname" placeholder="Search By Name" />
                </div>
              </div>
              <div className="col-4">
                <div className="form-group mb-4 position-relative">
                  <label for="eventname" className="form-label over-label2">Date of Event</label>
                  <input type="text" className="form-control pd-tb-675em" name="eventdate" placeholder="mm/dd/yyyy" />
                </div>
              </div>
              <div className="col-4">
                <div className="form-group mb-4 position-relative">
                  <select className="form-select pd-tb-675em" aria-label="Search Domain">
                    <option value="" selected disabled>Search By Domain</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        <hr></hr>
        <div className="row bg-light p-2 pt-4 mt-3 mb-3 rounded rounded-2">
          <div className="col-md-10 mb-4">

          </div>
          {/* <div className="col-md-2 view-mode-btn text-end mb-3">
            <a href="#" className="btn" id="list2"> <i className="fa fa-list p-2 fs-4" aria-hidden="true"></i></a>
            <a href="#" className="btn active_btn2" id="grid2"> <i className="fa fa-th p-2 fs-4" aria-hidden="true"></i></a>
          </div> */}
          <div className="col-12">
            <div className="row view-group" id="products2">

              {filteredList.map((item, index) => <div className="col-md-3 mb-3" >
                <div className="card p-3 event-card crdev_red">
                  <div className="imgrel">
                    <Link
                      to={{
                        pathname: "/mission-products-detail",
                        search: `?id=${item.post_id || item.ID}`,
                        state: { productDetails: item }
                      }}
                    >  <img src={item.product_image[0]} className="img-fluid card-img-top rounded prod-img" alt="products" /></Link>

                    <div className="card-img-overlay pazre">
                      <Link to={{
                        pathname: '/edit-mission-products',
                        search: `?id=${item.ID}&blog=${userData.blog_id?.userblog_id}`,
                        state: { productDetails: item }
                      }}
                        className="btn d-block">
                        <img src={editicoSvg} alt="edit product" />
                      </Link>
                    </div>
                  </div>
                  <div className="evtxcn px-0 ">
                    <h4 className="evh">
                      <span className="evhd p-tit t3">{item.post_title}
                        <span className="card-subtitle mb-2 text-dark float-end fw-bold t3"><i className="fa fa-inr" aria-hidden="true" /> {item.product_price}</span>
                      </span>
                    </h4>
                    <span className="muted d-block mt-1 doccell t4">
                      <img src={drprocoSvg} alt="name" /> {item.brand}
                    </span>
                    <p className="evdes_nw t4">{item.post_content}</p>
                  </div>
                </div>
                <div className={item.post_status === "pending" ? "crbotm_red" : "crbotm"}>
                  <p className="dtpr fs-9">Created - <span className="cdte">{moment(item.post_date).format("Do MMM YYYY")}</span></p>
                  <span className="dtpr fs-9">/</span>
                  <Link to='/' className="linknormal" data-bs-toggle="modal" data-bs-target="#productapproval"><p className="dtpr fs-9">{item.post_status}
                  </p></Link>
                </div>
              </div>)}
              {fullyLoaded ? <span> </span> : <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button
                  style={{
                    backgroundColor: "#beeadc",
                    border: "none",
                    borderRadius: "10px",
                    padding: "10px 2rem",
                    fontWeight: "semibold",
                  }}
                  onClick={e => this.onLoad()}
                >
                  Load More
                </button>
              </div>}
            </div>
          </div>
        </div>

        {/* ---------------- Product Approval Popup ---------------- */}
        <div className="modal fade" id="productapproval" tabIndex="-1" aria-labelledby="productapprovalLabel" aria-hidden="true">
          <div className="modal-dialog modal-xl">
            <div className="modal-content bg-white p-3">
              <div className="modal-header">
                <h1 className="modal-title fs-5 w-100" id="productapprovalLabel">Preview Product for approval</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="row mt-4">
                  <div className="col-12 p-3 mb-4 bg-light">
                    <h5>Product Approval</h5>
                    <div className="row">
                      <div className="col-12 mb-3">
                        <div className=""><b>Registered -</b> <span>20 October 2022</span> | <b className="ml-15">Updated on -</b> <span>24 October 2022</span></div>
                      </div>
                      <div className="col-md-8">
                        <div className="form-group position-relative">
                          <input aria-labelledby="comment" id="comment" type="text" className="form-control pd-tb-675em pb-3" placeholder="Enter the comments here" name="proposeapprove" />
                        </div>
                      </div>
                      <div className="col-md-2 text-end mob-btn-col"><button type="button" className="btn theme-btn-fill pd-tb-675em border-2 w-100">Approve</button></div>
                      <div className="col-md-2 mob-btn-col"><button type="button" className="btn theme-btn-outline pd-tb-675em border-2 w-100">Dis-Approve</button></div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="box-zoom">
                      <div className="product-images">
                        <div className="picZoomer">
                          <img src={require('../../../../public/product-thumb-main.jpg')} className="img-fluid my_img" alt="gallery" />
                        </div>
                      </div>
                      <div className="zoom-thumb">
                        <ul className="piclist">
                          <li><img src={require('../../../../public/product-thumb-1.jpg')} alt="thumbnail" /></li>
                          <li><img src={require('../../../../public/product-thumb-2.jpg')} alt="thumbnail" /></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <h5>Dr Vivek’s Naturopathy<button type="button" className="btn bg-body-secondary rounded rounded-4 float-end"><i className="fa fa-share" aria-hidden="true" /> Share</button></h5>
                    <span className="text-primary d-block mb-2 fw-bold">10 more products from this seller</span>
                    <span className="badge rounded-pill text-bg-morelight fw-normal mt-4">Ayush’s Pick</span>
                    <h4 className="mt-4 text-dark">Isha Sanjeevini Instant Drink for Your Health (500 g)</h4>
                    <p className="mt-4 text-dark">
                      <b>About this product :</b>  dolor sit amet consectetur adipisicing elit. Minus ratione
                      enim ea nam magnam eligendi repellendus pariatur
                      exercitationem aliquam commodi</p>

                    <div className="mt-4 p-des">
                      <p className="fs-3 fw-bold text-dark mb-0 pb-0">
                        <i className="fa fa-inr" aria-hidden="true" /> 3,595
                      </p>
                      <span className="mt-2 d-block">Local taxes included (where applicable)</span>
                      <span className="mt-4 d-block text-dark fw-bold">Buy online below...</span>
                      <div className="mt-2">
                        <button type="button" className="btn btn-dark p-2 px-4"><i className="fa fa-link fs-4" aria-hidden="true" /> Link 1</button> <button type="button" className="btn btn-dark p-2 px-4"><i className="fa fa-link fs-4" aria-hidden="true" /> Link 2</button> <button type="button" className="btn btn-dark p-2 px-4"><i className="fa fa-link fs-4" aria-hidden="true" /> Link 3</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-4 my-4 bg-dark-subtle highlighted-row p-3 rounded rounded-4">
                  <div className="col-md-6 border-end border-4 border-white px-4">
                    <b>Product Effective for</b>
                    <p className="d-block mt-2">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione
                      enim ea nam magnam eligendi repellendus pariatur
                      exercitationem aliquam commodi</p>
                  </div>
                  <div className="col-md-6 px-4">
                    <b>Ingredients</b>
                    <p className="d-block mt-2">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione
                      enim ea nam magnam eligendi repellendus pariatur
                      exercitationem aliquam commodi</p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <p>
                      <b>Product Description</b>
                      <span className="mt-2 d-block">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus pariatur
                        exercitationem aliquam commodi quibusdam earum neque impedit, porro totam corporis ipsum ipsam quis! Lorem ipsum, dolor sit amet consectetur
                        adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus pariatur exercitationem aliquam commodi quibusdam earum neque impedit,
                        porro totam corporis ipsum ipsam quis!
                      </span>
                    </p>
                    <p>
                      <b>Legal Disclaimer</b>
                      <span className="mt-2 d-block">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus pariatur
                        exercitationem aliquam commodi quibusdam earum neque impedit, porro totam corporis ipsum ipsam quis! Lorem ipsum, dolor sit amet consectetur
                        adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus pariatur exercitationem aliquam commodi quibusdam earum neque impedit,
                        porro totam corporis ipsum ipsam quis!
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ---------------- Product Approval Popup End ---------------- */}

      </div>
    );
  }
}
export default MissionAllProducts;